import React from 'react';
import { History } from 'history';
import { Button, Card, Chip, Layout, Media, Text } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './product-model';  //editable..
import ProducttypeModel from '../producttype/producttype-model';
import UserModel from '../user/user-model';
import TransactiondetailCreatePublic from '../transactiondetail/transactiondetail-create-public.component';
import AddressPicklistCard from '../address/address-picklistcard.component';
import ProductPicklistCard from './product-picklistcard.component';
import TransactiondetailPicklistCard from '../transactiondetail/transactiondetail-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    onLoad?: (data: any) => void;
}

interface IState {
    datarow: Model;
    datarowTransactiondetailReview: any;
    errors: any;
    disableSwipe?: boolean;
}

export default class ProductViewPublic extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            datarowTransactiondetailReview: null,
            errors: null,
            disableSwipe: false,
        }
    }
  
    private isMobile: boolean = AppService.isMobile();

    private priceWords = () => {
        return (
        <>
            {this.state.datarow.totalamount !== 0 &&
            <Text label={AppService.currencySymbol + ' ' + AppService.strToMoney((this.state.datarow.pricebase + this.state.datarow.margin).toString())} color='text.secondary' bold displayBlock sx={{text: {textDecorationLine: 'line-through'}}} >
                <Chip label={this.state.datarow.amounttypeCaption} type='info' sx={{ml: 1}}/>
            </Text>
            }
            {this.state.datarow.pricesale > 0 &&
            <Text label={AppService.currencySymbol + ' ' + AppService.strToMoney(this.state.datarow.pricesale.toString())} color='text.secondary' size={this.isMobile? 'large' : 'extralarge'} bold marginBottom={1}/>
            }
            {this.state.datarow.qty > 0 &&
            <Text label={'Masih tersedia untuk ' + this.state.datarow.qty.toString() + ' ' + this.state.datarow.unit} color='text.secondary' icon='loyalty' iconSize='extrasmall' marginBottom={1}/>
            }
        </>
        )
    }

    private soldWords = () => {
        const description = ProducttypeModel.optionType.filter((d: any) => d.name === this.state.datarow.producttypeType)?.[0]?.description;
        const totalQty = this.state.datarowTransactiondetailReview?.total.qty;
        const unit = this.state.datarow.unit;
        
        if (description && totalQty && unit)
            return <Text label= {'Sudah ' + description + ' ' + totalQty + ' ' + unit} color='text.secondary' icon='local_mall' iconSize='extrasmall' marginBottom={1}/>;
    }

    private onLoad = (data: any) => {
        this.setState({datarow: data});
    }

    private onLoadTransactiondetail = (data: any) => {
        if (data.transaction) {
            const menu = [
                {caption: '', icon: 'shopping_cart', badge: 1, url: '/transaction', historyState: {'id': data.transaction}},
            ];
            this.props.onLoad?.({appbar: {menu: menu}});
        }
    }

    private onLoadTransactiondetailReview = (data: any) => {
        this.setState({ datarowTransactiondetailReview: data});
    }

    private onChangeSwipe = (value: string) => {
        this.setState({ disableSwipe: value.startsWith('move')})
    }

    private onClickUserSignin = () => {
        this.props.history.replace({}, AppService.historyState('authSignin', !UserModel.isSignin()));
    }
    
    private onClickEvent = () => {
        this.props.history.replace('/event', AppService.historyState('id', this.state.datarow.event));
    }
    
    public componentDidUpdate() {
        //restore id after user signin
        if (!AppService.historyState()?.id && this.state.datarow.id)
            this.props.history.replace({}, AppService.historyState('id', this.state.datarow.id));
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} caption={this.state.datarow.name}
                model={Model} onLoad={this.onLoad}> 
                
                {this.state.datarow.id > 0 &&
                <Layout history={this.props.history} direction={this.isMobile? 'row' : 'row-reverse'} spacing={3} content={[                    
                    {caption: 'Order', color: 'background.paper', disableCard: true, child: 
                    <>
                        {this.priceWords()}
                        {!UserModel.isSignin()?
                            <Button type='contained' label={this.state.datarow.pricesale > 0? 'Masukan keranjang' : 'Silahkan login'} textTransform='capitalize' startIcon='shopping_cart' sx={{marginTop: 3}} onClick={this.onClickUserSignin}/>
                        : this.state.datarow.pricesale > 0 && this.state.datarow.qty > 0?
                            <TransactiondetailCreatePublic history={this.props.history} productId={this.state.datarow.id} onLoad={this.onLoadTransactiondetail}/> 
                        : this.state.datarow.pricesale === 0 && this.state.datarow.event && this.state.datarow.eventAstemplate === 'no' &&
                            <Button type='contained' label='Gratis! Ikuti sekarang' textTransform='none' sx={{marginTop: 3}} onClick={this.onClickEvent}/>
                        }
                    </>
                    },
                    
                    {caption: 'Rincian', disableCard: true, disableSwipe: this.state.disableSwipe, child: 
                    <Card direction={this.isMobile? 'column': 'row'} borderWidth={0} borderRadius={2} media={ <Media url={this.state.datarow.imageUrl} sx={{borderRadius: 2}}/> } >
                        {!!this.isMobile && this.priceWords()}
                        {!this.isMobile && this.soldWords()}
                        <Text label={this.state.datarow.description} textAlign='justify' textToHtml showMore={300}/>
                        <AddressPicklistCard history={this.props.history} caption=' ' nodataCaption =' ' parentType='product' parentId={this.state.datarow.id} cardIconOnly onLoad={(d) => AppService.openLink(d.linkPath)}/>
                    </Card>                                
                    },
                    
                    {caption: 'Ulasan', disableCard: true, disableSwipe: this.state.disableSwipe, child: 
                        <>
                        {!!this.isMobile && this.soldWords()}
                        <TransactiondetailPicklistCard history={this.props.history} caption={this.isMobile? ' ' : 'Ulasan'} nodataCaption ='Belum ada ulasan' productId={this.state.datarow.id} transactionStatus='approved' onLoad={this.onLoadTransactiondetailReview} cardCount={3} swipe='horizontal' disableSearch/>
                        </>
                    },                    
                    ]}
                />
                }    
                
                <ProductPicklistCard history={this.props.history} caption='Produk lainnya' pricetype='pricesale' cardCount={6} swipe='horizontal' onLoad={this.onLoad} onChangeSwipe={this.onChangeSwipe} disableSearch/>
                   
            </BaseView>
        );
    }
}